import { render, staticRenderFns } from "./MySpotsOrders.vue?vue&type=template&id=4e42b070&scoped=true&"
import script from "./MySpotsOrders.vue?vue&type=script&lang=js&"
export * from "./MySpotsOrders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e42b070",
  null
  
)

export default component.exports